function fetchPublicationQuery (rootQueryType, id, pageSize, page, sortField, sortOrder, filter) {
  rootQueryType = ['organisationalUnit', 'person'].includes(rootQueryType) ? rootQueryType : null
  id = rootQueryType === 'organisationalUnit' ? Number(id) : `${id}`

  // if the rootQueryType does not match for organisational unit or person then return nulls
  if (!rootQueryType) {
    return null
  }

  let variables = {
    id: id || null,
    pageSize: Number(pageSize) || 20,
    page: Number(page) || 1
  }

  if (sortOrder) {
    variables['sortOrder'] = sortOrder
  }

  if (sortField) {
    variables['sortField'] = sortField
  }

  if (filter && filter.year && Number(filter.year)) {
    variables['filterYear'] = Number(filter.year)
  }

  if (filter && filter.freetext && filter.freetext.length > 0) {
    variables['filterFreetext'] = filter.freetext
  }

  if (filter && filter.person && filter.person.length > 0) {
    variables['filterPerson'] = filter.person
  }

  if (filter && filter.category && filter.category.length > 0) {
    variables['filterCategory'] = filter.category
  }

  if (filter && filter.inProject) {
    variables['filterInProject'] = filter.inProject
  }

  if (filter && filter.inProject && filter.fundedByCategory) {
    variables['filterFundedByCategory'] = filter.fundedByCategory
  }

  return {
    operationName: 'fetchPublicationQuery',
    query: `
      query fetchPublicationQuery(
        $id: ID!,
        $pageSize: Int!,
        $page: Int!,
        $sortOrder: SortOrder,
        $sortField: PublicationSortKeys,
        $filterYear: Int,
        $filterFreetext: String,
        $filterPerson: String,
        $filterCategory: String,
        $filterInProject: Boolean,
        $filterFundedByCategory: FundingAgencyCategory,
      ) {
        ${rootQueryType}(id: $id) {
          publikation:publications(
            pageSize: $pageSize, page: $page, sortOrder: $sortOrder, orderBy:$sortField,
            filter: {
              year: $filterYear
              freeText: $filterFreetext
              person: $filterPerson
              category: $filterCategory
              inProject: $filterInProject
              fundedByCategory: $filterFundedByCategory
            }
          ) {
            meta {
              pageNumber
              pageSize
              totalEntries
              totalPages
            }
            entries {
              ... on Publication {
                _id:id
                _entityName
                publikationsTyp:typeDe
                html {
                  de
                  en
                }
              }
            }
          }
        }
      }
    `,
    variables
  }
}

export { fetchPublicationQuery }



// WEBPACK FOOTER //
// ./src/graphql/publication.js